const baseUrl = import.meta.env.VITE_API_URL;

export const apiUrl = `${baseUrl}/admin`;

export const apiUrlV2 = `${baseUrl}`;

function parseUrlWithOptionalScheme(raw: string): URL | null {
  const t = raw.trim();
  if (!t) return null;
  try {
    return new URL(t.includes("://") ? t : `https://${t}`);
  } catch {
    return null;
  }
}

function inferCdnUrl(): string {
  const raw = (import.meta.env.VITE_CDN_URL ?? "").trim().replace(/\/$/, "");
  if (raw) {
    const u = parseUrlWithOptionalScheme(raw);
    if (u) return u.origin;
  }
  const api = (import.meta.env.VITE_API_URL ?? "").toLowerCase();
  if (
    api.includes("staging") ||
    api.includes("localhost") ||
    api.includes("127.0.0.1") ||
    api === ""
  ) {
    return "https://cdn-staging.gymlive.app";
  }
  return "https://cdn.gymlive.app";
}

/** Aligns with portal; deploy sets `VITE_CDN_URL` from `infra/common.ts`. */
export const cdnUrl = inferCdnUrl();
